'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"fill-dark-grey":"expander-module_fill-dark-grey__512sN","view-more__btn":"expander-module_view-more__btn__LBzK9"};

exports.default = styles;
//# sourceMappingURL=expander.module.scss.js.map
